/* eslint-disable import/prefer-default-export */

import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PaymentGatewayConnectionModelMC from '../../../models/PaymentGatewayConnectionModelMC';
import { buildPaymentMethods } from '../services/buildPaymentMethods';

export const usePaymentGatewayConnections = ({ order = {} }) => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [serializedPaymentMethods, setSerializedPaymentMethods] = useState([]);

  const { retailer_info } = useSelector((state) => state.retailerUsersReducer);

  useEffect(() => {
    PaymentGatewayConnectionModelMC.get().then((res) => {
      setPaymentMethods(res.gateways);
    });
  }, []);

  useEffect(() => {
    setSerializedPaymentMethods(buildPaymentMethods({ paymentMethods, retailerInfo: retailer_info, order }));
  }, [paymentMethods, retailer_info, order]);

  return { paymentMethods, serializedPaymentMethods };
};
